<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';

const AiStorymapApp = defineComponent({
    name: 'AiStorymapApp',

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const state = reactive({});

        return {
            state,
        };
    },
});

export default AiStorymapApp;
</script>

<template>
  <v-app>
    <v-main style="height: 100%;">
      <v-slide-y-transition mode="out-in">
        <router-view class="full-height" style="overflow-y: auto;" />
      </v-slide-y-transition>
    </v-main>
    
    <AppSnackbar />
    
    <AppConfirm />
  </v-app>
</template>

<style lang='scss' scoped>
.theme--light {
    &.v-application {
        background: transparent !important;

        ::v-deep .v-text-field--solo.error--text {
            .v-input__slot {
                border: none !important;
            }
        }
    }
}
</style>